import listActions from 'src/modules/image/list/imageListActions';
import ImageService from 'src/modules/image/imageService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import Message from 'src/view/shared/message';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'IMAGE_DESTROY';

const imageDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: imageDestroyActions.DESTROY_STARTED,
      });

      await ImageService.destroyAll([id]);

      dispatch({
        type: imageDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(i18n('entities.image.destroy.success'));

      dispatch(listActions.doFetchCurrentFilter());

      navigateTo('/library/image');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: imageDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: imageDestroyActions.DESTROY_ALL_STARTED,
      });

      await ImageService.destroyAll(ids);

      dispatch({
        type: imageDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(i18n('entities.image.destroyAll.success'));

      navigateTo('/library/image');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: imageDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default imageDestroyActions;
